import { Base } from './base';
import { IUser } from './user';

export interface IEvent extends Base {
	photoUrl?: string;
	title: string;
	description?: string;
	date: Date;
	location: string;
	creator?: IUser;
	invitees?: IUser[];
	attendants?: IUser[];
	attendantsLimit?: number;
	visibility: EventVisibility;
	type: EventType;
	status: EventStatus;
}

export enum EventStatus {
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
}

export enum EventType {
	InPerson = 'inPerson',
	Virtual = 'virtual',
}

export enum EventVisibility {
	Public = 'public',
	Private = 'private',
}
